/* Keiiarra · kei-cards.js · v21 (3 Sep 2026)

   AUDIT NOTE. Three add-to-cart systems were running at once:
     A) theme.js  — submits product forms, relabels the button "Adding…" then
        "Added ✓" then restores the old label on a 1.6s timer.
     B) blueprint-3.js + blueprint-sync.js — the prototype buttons (.add-set,
        .add-cart) with their own cart object mirrored to Shopify.
     C) this file — the stepper.
   A and C were fighting: this file hides the button and shows a stepper, then
   theme.js writes a label onto the hidden button after the fact, so the button
   came back reading "Adding…" for ever.

   v21 makes ONE system own the add. This file now intercepts the form submit in
   the capture phase and stops it reaching theme.js, so nothing else touches the
   button. Blueprint's own buttons (.add-set, .add-cart) still do their own add,
   which is correct, but they now get the stepper too. */
(function () {
  'use strict';

  var lastCart = null;
  var handleMap = {};   /* blueprint key or product handle -> variant id */
  var pending = {};
  var timers = {};
  var lines = {};
  var undoTimer = null;

  try {
    var vNode = document.querySelector('script[data-kei-variants]');
    if (vNode) {
      var vJson = JSON.parse(vNode.textContent || '{}');
      Object.keys(vJson).forEach(function (k) {
        if (vJson[k] && vJson[k].variant) handleMap[k] = String(vJson[k].variant);
      });
    }
  } catch (e) {}

  function hasPending() { return Object.keys(pending).length > 0; }

  /* ---------- variant pills ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var more = e.target.closest('.pc-more');
    if (more) {
      e.preventDefault();
      var mbox = more.closest('.p-card__vars');
      if (mbox) mbox.classList.add('show-all');
      more.remove();
      return;
    }

    var b = e.target.closest('.pc-var');
    if (!b || b.disabled) return;
    e.preventDefault();
    var card = b.closest('.p-card');
    if (!card) return;
    Array.prototype.forEach.call(card.querySelectorAll('.pc-var'), function (x) { x.classList.remove('on'); });
    b.classList.add('on');
    var id = card.querySelector('input[name="id"]');
    if (id) id.value = b.getAttribute('data-vid');
    var out = card.querySelector('[data-price-out]');
    if (out && b.getAttribute('data-price')) out.textContent = b.getAttribute('data-price');
    var img = card.querySelector('.p-card__media img');
    if (img && b.getAttribute('data-img')) { img.removeAttribute('srcset'); img.src = b.getAttribute('data-img'); }
    syncAdders();
  });

  /* ---------- shop-by-need chips ---------- */
  var bar = document.querySelector('[data-nudgebar]');
  if (bar) {
    var chips = Array.prototype.slice.call(bar.querySelectorAll('.nudge-chip'));
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-tag-item]'));
    var apply = function (t) {
      items.forEach(function (it) {
        var tags = (it.getAttribute('data-tags') || '').split(',');
        it.style.display = (t === 'all' || tags.indexOf(t) > -1) ? '' : 'none';
      });
    };
    bar.addEventListener('click', function (e) {
      var c = e.target.closest ? e.target.closest('.nudge-chip') : null;
      if (!c) return;
      chips.forEach(function (x) { x.classList.remove('on'); });
      c.classList.add('on');
      var t = c.getAttribute('data-tag-filter') || 'all';
      apply(t);
      try {
        var u = new URL(location.href);
        if (t === 'all') u.searchParams.delete('pick'); else u.searchParams.set('pick', t);
        history.replaceState(null, '', u);
      } catch (err) {}
    });
    try {
      var pre = new URL(location.href).searchParams.get('pick');
      if (pre) {
        var m = bar.querySelector('.nudge-chip[data-tag-filter="' + pre + '"]');
        if (m) m.click();
      }
    } catch (err2) {}
  }

  /* ---------- Candles in the hamburger drawer ---------- */
  var nd = document.querySelector('.nd-links');
  if (nd) {
    var existing = nd.querySelector('a[href="/collections/all-candles"]');
    if (existing) {
      if (!existing.querySelector('.kn-new')) existing.innerHTML = 'Candles<i class="kn-new">New</i>';
    } else {
      var a = document.createElement('a');
      a.href = '/collections/all-candles';
      a.innerHTML = 'Candles<i class="kn-new">New</i>';
      a.addEventListener('click', function () {
        if (typeof window.closeNav === 'function') window.closeNav();
      });
      var after = nd.querySelector('a[href="/pages/gift-sets"]');
      if (after) { after.insertAdjacentElement('afterend', a); } else { nd.appendChild(a); }
    }
  }

  /* ---------- desktop header drop-downs ---------- */
  var navRoot = document.querySelector('[data-kei-nav]');
  if (navRoot) {
    var groups = Array.prototype.slice.call(navRoot.querySelectorAll('[data-kn]'));
    var closeAll = function (except) {
      groups.forEach(function (g) {
        if (g === except) return;
        g.classList.remove('open');
        var t = g.querySelector('.kn-top');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    };
    groups.forEach(function (g) {
      var top = g.querySelector('.kn-top');
      if (!top) return;
      top.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = g.classList.contains('open');
        closeAll(g);
        g.classList.toggle('open', !isOpen);
        top.setAttribute('aria-expanded', String(!isOpen));
      });
      g.addEventListener('mouseleave', function () {
        g.classList.remove('open');
        top.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-kn]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* ---------- styles ---------- */
  var css = document.createElement('style');
  css.textContent =
    '#cdItems{display:block !important;visibility:visible !important;opacity:1 !important;height:auto !important;overflow-y:auto}' +
    '.kcd-row{display:flex !important;gap:11px;align-items:center;padding:12px 0;border-bottom:1px solid rgba(251,245,232,.14)}' +
    '.kcd-row img{width:52px;height:64px;object-fit:cover;border-radius:7px;flex:0 0 52px}' +
    '.kcd-meta{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;align-items:flex-start;gap:3px}' +
    '.kcd-meta a{color:#FBF5E8;text-decoration:none;font:600 .84rem Inter,sans-serif;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.kcd-var{font:400 .7rem Inter,sans-serif;color:#FBF5E8;opacity:.6}' +
    '.kcd-meta b{font:700 .78rem Inter,sans-serif;color:#E9B949}' +
    '.kcd-qty{display:inline-flex !important;align-items:stretch;margin-top:6px;border:2px solid #E9B949;border-radius:999px;overflow:hidden;width:max-content;opacity:1 !important;background:transparent}' +
    '.kcd-step{background:transparent;border:0;color:#E9B949 !important;font:800 1.15rem/1 Inter,sans-serif;width:34px;height:32px;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;opacity:1 !important}' +
    '.kcd-step:disabled{opacity:.4 !important;cursor:not-allowed}' +
    '.kcd-n{background:#E9B949 !important;color:#2B0E12 !important;font:800 1rem/32px Inter,sans-serif !important;min-width:34px;padding:0 5px;text-align:center;display:block;opacity:1 !important}' +
    '.kcd-x{background:none;border:0;color:#FBF5E8;opacity:.45;font-size:.9rem;cursor:pointer;padding:6px;align-self:flex-start}' +
    '.katc-qty{display:inline-flex;align-items:stretch;box-sizing:border-box;border:1px solid #2B0E12;border-radius:6px;overflow:hidden;background:#2B0E12;vertical-align:top}' +
    '.katc-step{background:#2B0E12;border:0;color:#E9B949;font:800 1.1rem/1 Inter,sans-serif;flex:0 0 40px;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center}' +
    '.katc-step:active{background:#4A1A20}' +
    '.katc-n{flex:1 1 auto;background:#FBF5E8;color:#2B0E12;font:800 .92rem Inter,sans-serif;display:flex;align-items:center;justify-content:center;min-width:38px}' +
    '.pdp__gallery{align-self:flex-start}' +
    '.pdp-dots{display:flex;gap:7px;justify-content:center;align-items:center;min-height:16px;margin:10px 0 0}' +
    '.pdp-dots .pdp-dot{width:7px;height:7px;border-radius:99px;border:0;padding:0;background:rgba(43,14,18,.25);cursor:pointer;transition:width .25s ease,background .25s ease}' +
    '.pdp-dots .pdp-dot.on{background:#2B0E12;width:20px}' +
    '.kei-undo{position:fixed;left:50%;bottom:calc(84px + env(safe-area-inset-bottom,0px));transform:translate(-50%,14px);z-index:10000;display:none;align-items:center;gap:14px;background:#2B0E12;color:#FBF5E8;border:1px solid rgba(233,185,73,.5);border-radius:999px;padding:11px 12px 11px 18px;box-shadow:0 14px 34px -14px rgba(0,0,0,.7);opacity:0;transition:opacity .22s ease,transform .22s ease;max-width:calc(100vw - 32px)}' +
    '.kei-undo.on{display:flex;opacity:1;transform:translate(-50%,0)}' +
    '.kei-undo span{font:500 .82rem Inter,sans-serif;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.kei-undo button{background:#E9B949;color:#2B0E12;border:0;border-radius:999px;font:800 .72rem Inter,sans-serif;letter-spacing:.08em;text-transform:uppercase;padding:8px 15px;cursor:pointer;flex:0 0 auto}' +
    '@media(min-width:900px){.kei-undo{bottom:28px;left:28px;transform:translate(0,14px)}.kei-undo.on{transform:translate(0,0)}}';
  document.head.appendChild(css);

  /* ---------- undo toast ---------- */
  var undoEl = document.createElement('div');
  undoEl.className = 'kei-undo';
  undoEl.setAttribute('role', 'status');
  undoEl.innerHTML = '<span></span><button type="button">Undo</button>';
  document.body.appendChild(undoEl);
  var undoText = undoEl.querySelector('span');
  var undoBtn = undoEl.querySelector('button');

  function nounFor(item) {
    var t = ((item.product_type || '') + ' ' + (item.product_title || '')).toLowerCase();
    if (t.indexOf('bundle') > -1 || t.indexOf('gift box') > -1 || t.indexOf('collection') > -1) return 'set';
    if (t.indexOf('kit') > -1 || t.indexOf('sampler') > -1) return 'kit';
    if (t.indexOf('diya') > -1 || t.indexOf('plate') > -1) return 'plate';
    if (t.indexOf('candle') > -1 || t.indexOf('sachet') > -1) return 'candle';
    if (t.indexOf('parfum') > -1 || t.indexOf('perfume') > -1) return 'scent';
    return 'item';
  }
  function showUndo(item) {
    if (!item) return;
    undoText.textContent = (item.product_title || 'That') + ', ' + nounFor(item) + ' removed';
    undoEl.classList.add('on');
    clearTimeout(undoTimer);
    undoTimer = setTimeout(function () { undoEl.classList.remove('on'); }, 6000);
    undoBtn.onclick = function () {
      undoEl.classList.remove('on');
      clearTimeout(undoTimer);
      var body = { items: [{ id: item.variant_id, quantity: item.quantity }] };
      if (item.properties && Object.keys(item.properties).length) body.items[0].properties = item.properties;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      }).then(renderCart).catch(renderCart);
    };
  }

  /* ---------- the cart ---------- */
  var lastHTML = '';
  var guard = null;

  function inr(paise) { return '\u20b9' + Math.round(paise / 100).toLocaleString('en-IN'); }
  function thumb(url) { return url ? url.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2') : ''; }
  function unhide(el) {
    if (!el) return;
    el.style.removeProperty('display');
    el.style.removeProperty('visibility');
    el.style.removeProperty('opacity');
    el.style.removeProperty('height');
    el.hidden = false;
  }

  function renderCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        lastCart = cart;
        cart.items.forEach(function (it) { lines[it.key] = it; });

        if (hasPending()) {
          cart.items.forEach(function (it) {
            if (pending.hasOwnProperty(it.key)) it.quantity = pending[it.key];
          });
          syncAdders();
          return cart;
        }

        var box = document.getElementById('cdItems');
        var empty = document.getElementById('cdEmpty');
        var foot = document.getElementById('cdFoot');
        var total = document.getElementById('cdTotal');

        if (box) {
          if (!cart.item_count) {
            lastHTML = '';
            box.innerHTML = '';
            if (empty) empty.style.display = '';
            if (foot) foot.style.display = 'none';
          } else {
            if (empty) empty.style.display = 'none';
            if (foot) { unhide(foot); foot.style.display = ''; }
            lastHTML = cart.items.map(function (it) {
              var variant = (it.variant_title && it.variant_title !== 'Default Title')
                ? '<span class="kcd-var">' + it.variant_title + '</span>' : '';
              var pic = it.image ? '<img src="' + thumb(it.image) + '" alt="" loading="lazy">' : '';
              var qty =
                '<span class="kcd-qty">' +
                  '<button class="kcd-step" data-key="' + it.key + '" aria-label="Reduce quantity"' + (it.quantity <= 1 ? ' disabled' : '') + '>\u2212</button>' +
                  '<span class="kcd-n">' + it.quantity + '</span>' +
                  '<button class="kcd-step" data-key="' + it.key + '" aria-label="Increase quantity">+</button>' +
                '</span>';
              return '<div class="kcd-row">' + pic +
                '<div class="kcd-meta"><a href="' + it.url + '">' + it.product_title + '</a>' + variant +
                '<b>' + inr(it.final_line_price) + '</b>' + qty + '</div>' +
                '<button class="kcd-x" data-key="' + it.key + '" aria-label="Remove">\u2715</button></div>';
            }).join('');
            box.innerHTML = lastHTML;
            unhide(box);
            if (total) total.textContent = inr(cart.total_price);
          }
        }
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var cc = document.getElementById('cartCount'); if (cc) cc.textContent = cart.item_count;
        var fc = document.getElementById('fabCount'); if (fc) fc.textContent = cart.item_count;
        syncAdders();
        return cart;
      })
      .catch(function () {});
  }
  window.keiRenderCart = renderCart;

  function queueLine(key, quantity) {
    if (!key) return;
    pending[key] = quantity;
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () {
      var target = pending[key];
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: target })
      }).then(function () {
        if (pending[key] === target) delete pending[key];
        return renderCart();
      }).catch(function () {
        delete pending[key];
        renderCart();
      });
    }, 320);
  }

  function removeLine(key) {
    var snapshot = lines[key];
    queueLine(key, 0);
    showUndo(snapshot);
  }

  /* ---------- stepper ---------- */
  function lineFor(vid) {
    if (!lastCart || !lastCart.items || !vid) return null;
    for (var i = 0; i < lastCart.items.length; i++) {
      if (String(lastCart.items[i].variant_id) === String(vid)) return lastCart.items[i];
    }
    return null;
  }
  function resetButton(el) {
    if (!el) return;
    var label = el.getAttribute('data-label');
    if (label) el.textContent = label;
    el.disabled = false;
    el.classList.remove('is-loading', 'loading', 'is-busy', 'added');
    el.removeAttribute('aria-busy');
  }
  function swap(anchorEl, line) {
    if (!anchorEl || !anchorEl.parentNode) return;
    var box = anchorEl.parentNode.querySelector('.katc-qty');
    if (line && line.quantity > 0) {
      var w = anchorEl.offsetWidth || 0;
      var h = anchorEl.offsetHeight || 0;
      if (!box) {
        box = document.createElement('div');
        box.className = 'katc-qty';
        anchorEl.insertAdjacentElement('afterend', box);
      }
      if (w) box.style.width = w + 'px';
      if (h) box.style.height = h + 'px';
      box.innerHTML =
        '<button type="button" class="katc-step" data-key="' + (line.key || '') + '" data-d="-1" aria-label="Reduce quantity">\u2212</button>' +
        '<span class="katc-n">' + line.quantity + '</span>' +
        '<button type="button" class="katc-step" data-key="' + (line.key || '') + '" data-d="1" aria-label="Add one more">+</button>';
      box.style.display = '';
      anchorEl.style.display = 'none';
    } else {
      if (box) box.style.display = 'none';
      resetButton(anchorEl);
      anchorEl.style.display = '';
    }
  }

  /* every kind of add button on the store resolves to a variant here */
  function variantForTrigger(el) {
    if (!el) return null;
    var f = el.closest ? el.closest('form') : null;
    if (f) {
      var idEl = f.querySelector('[name="id"]');
      if (idEl && idEl.value) return idEl.value;
    }
    var key = el.getAttribute ? el.getAttribute('data-id') : null;   /* blueprint .add-set */
    if (key && handleMap[key]) return handleMap[key];
    var href = el.getAttribute ? (el.getAttribute('href') || '') : '';
    if (href.indexOf('/products/') > -1) {                            /* blueprint .add-cart */
      var handle = href.split('/products/')[1].split(/[?#]/)[0].replace(/\/$/, '');
      if (handleMap[handle]) return handleMap[handle];
    }
    return null;
  }

  var TRIGGERS = '[data-ajax-add], a.add-cart[href*="/products/"], .add-set[data-id]';

  function syncAdders() {
    if (!lastCart) return;
    try {
      Array.prototype.forEach.call(document.querySelectorAll(TRIGGERS), function (el) {
        var vid = variantForTrigger(el);
        if (vid) swap(el, lineFor(vid));
      });
    } catch (err) {}
  }
  function optimisticAdd(trigger) {
    var vid = variantForTrigger(trigger);
    if (!vid) return;
    var line = lineFor(vid);
    swap(trigger, { key: line ? line.key : '', quantity: (line ? line.quantity : 0) + 1 });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('select[name="id"]')) syncAdders();
  });

  /* ---------- WE own the product form submit ----------
     Capture phase + stopImmediatePropagation, so theme.js never sees it and
     never relabels the button. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;
    var btn = form.querySelector('[data-ajax-add]');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    optimisticAdd(btn);

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return renderCart(); })
      .catch(function () {
        resetButton(btn);
        var box = form.querySelector('.katc-qty');
        if (box) box.style.display = 'none';
        btn.style.display = '';
        form.submit();          /* last resort: let the browser do it */
      });
  }, true);

  /* ---------- gallery dots ---------- */
  (function galleryDots() {
    var sw = document.getElementById('pdpSwipe');
    var dots = document.getElementById('pdpDots');
    if (!sw || !dots) return;
    var slides = Array.prototype.slice.call(sw.querySelectorAll('.pdp-slide'));
    if (slides.length < 2) { dots.style.display = 'none'; return; }
    function build() {
      dots.innerHTML = '';
      slides.forEach(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'pdp-dot' + (i === 0 ? ' on' : '');
        d.setAttribute('aria-label', 'Photo ' + (i + 1));
        d.addEventListener('click', function () {
          sw.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(d);
      });
    }
    function mark() {
      var mid = sw.scrollLeft + sw.clientWidth / 2;
      var best = 0, bestD = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('on', i === best); });
    }
    build();
    sw.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    new MutationObserver(function () {
      if (dots.children.length !== slides.length) { build(); mark(); }
    }).observe(dots, { childList: true });
  })();

  /* ---------- drawer guard ---------- */
  function startGuard() {
    var box = document.getElementById('cdItems');
    if (!box || guard) return;
    guard = new MutationObserver(function () {
      if (!lastHTML || hasPending()) return;
      if (!box.querySelector('.kcd-row')) box.innerHTML = lastHTML;
      if (box.style.display === 'none' || box.hidden) unhide(box);
    });
    guard.observe(box, { childList: true, attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
  }

  var origOpen = window.openCart;
  window.openCart = function () {
    var r = (typeof origOpen === 'function') ? origOpen.apply(this, arguments) : null;
    if (typeof origOpen !== 'function') {
      var d = document.getElementById('cartDrawer');
      var o = document.getElementById('cartOverlay');
      if (d) d.classList.add('open');
      if (o) o.classList.add('open');
    }
    startGuard();
    renderCart();
    setTimeout(renderCart, 120);
    setTimeout(renderCart, 400);
    return r;
  };

  window.keiCheckout = function () { window.location.href = '/checkout'; };

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var dStep = e.target.closest('.kcd-step');
    if (dStep && !dStep.disabled) {
      e.preventDefault();
      var row = dStep.closest('.kcd-row');
      var dn = row ? row.querySelector('.kcd-n') : null;
      var key = dStep.getAttribute('data-key');
      var now = dn ? parseInt(dn.textContent, 10) : NaN;
      if (isNaN(now)) now = 1;
      var next = now + (dStep.getAttribute('aria-label') === 'Add one more' ? 1 : -1);
      if (next < 1) next = 1;
      if (dn) dn.textContent = next;
      queueLine(key, next);
      return;
    }

    var x = e.target.closest('.kcd-x');
    if (x) {
      e.preventDefault();
      var r2 = x.closest('.kcd-row');
      if (r2) r2.style.display = 'none';
      removeLine(x.getAttribute('data-key'));
      return;
    }

    var pStep = e.target.closest('.katc-step');
    if (pStep) {
      e.preventDefault();
      e.stopPropagation();
      var pbox = pStep.closest('.katc-qty');
      var n = pbox ? pbox.querySelector('.katc-n') : null;
      var cur = n ? parseInt(n.textContent, 10) : NaN;
      if (isNaN(cur)) cur = 1;
      var d = parseInt(pStep.getAttribute('data-d'), 10) || 0;
      var want = cur + d;
      if (want < 0) want = 0;
      var k = pStep.getAttribute('data-key');
      if (want === 0) {
        if (pbox && pbox.previousElementSibling) swap(pbox.previousElementSibling, null);
        removeLine(k);
      } else {
        if (n) n.textContent = want;
        queueLine(k, want);
      }
      return;
    }

    /* blueprint buttons still do their own add; we only paint the stepper */
    var bpBtn = e.target.closest('a.add-cart[href*="/products/"]') || e.target.closest('.add-set[data-id]');
    if (bpBtn) {
      optimisticAdd(bpBtn);
      setTimeout(renderCart, 500);
      setTimeout(renderCart, 1400);
    }
  }, true);

  window.addEventListener('pageshow', renderCart);
  window.addEventListener('load', function () { syncAdders(); setTimeout(syncAdders, 400); });
  startGuard();
  renderCart();
  setTimeout(syncAdders, 600);
  setTimeout(syncAdders, 1500);
})();
